"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerItemLabels = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var FeatureFlags_1 = require("icf-search-client-shared/lib/FeatureFlags");
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var usePerformerItemLabelsStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    labelsWrapper: {
        fontSize: "8px",
        fontWeight: 500,
        lineHeight: "10px",
        position: "absolute",
        insetInlineEnd: "4px",
        textTransform: "uppercase",
        top: "4px",
        zIndex: 1,
        textAlign: "center",
    },
    isNewLabel: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.textOnDark,
        padding: "2px 4px",
        marginBottom: "4px",
    },
    // Some labels have hard coded background colors on purpose
    // and will be the same on all themes and skins.
    hasVibeLabel: {
        // background-color had an invalid value with styled-components
        // `background-color: #d222de};`
        backgroundColor: "#d222de",
        color: theme.colors.textOnDark,
        padding: "2px 4px",
        marginBottom: "4px",
    },
    hasPhoneLabel: {
        // background-color had an invalid value with styled-components
        // `background-color: #6f6f6f};`
        backgroundColor: "#6f6f6f",
        color: theme.colors.textOnDark,
        padding: "2px 4px",
        marginBottom: "4px",
    },
    specialShowLabel: {
        backgroundColor: "#7F44F7",
        color: theme.colors.textOnDark,
        padding: "2px 4px",
    },
    goldShowLabel: {
        backgroundColor: theme.colors.gold,
        color: theme.colors.textOnLight,
        padding: "2px 4px",
    },
}); });
var PerformerItemLabels = function (props) {
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext, Contexts_1.ISearchSkinConfigContext), 2), translate = _a[0].translate, skinConfig = _a[1];
    var isNew = props.isNew, showType = props.showType, hasVibe = props.hasVibe, hasVoip = props.hasVoip;
    var classes = usePerformerItemLabelsStyles();
    // Only render if at least 1 label should be shown.
    if (!isNew && !showType && !hasVoip && !hasVibe) {
        return null;
    }
    var showNew = isNew && (0, FeatureFlags_1.isFeatureFlagEnabled)("enable_search_new_model_labels", skinConfig);
    var showVibe = hasVibe && (0, FeatureFlags_1.isFeatureFlagEnabled)("enable_search_has_vibe_labels", skinConfig);
    var showVoip = hasVoip && (0, FeatureFlags_1.isFeatureFlagEnabled)("enable_search_has_voip_labels", skinConfig);
    return (React.createElement("div", { className: classes.labelsWrapper },
        showNew && (React.createElement("div", { className: classes.isNewLabel, "data-ta-locator": "PerformerItemLabels-newModel" }, translate("search.new_model"))),
        showVibe && (React.createElement("div", { className: classes.hasVibeLabel, "data-ta-locator": "PerformerItemLabels-hasVibe" }, translate("search.has_vibe"))),
        showVoip && (React.createElement("div", { className: classes.hasPhoneLabel, "data-ta-locator": "PerformerItemLabels-hasVoip" }, translate("search.has_voip"))),
        showType === "goldShow" && React.createElement("div", { className: classes.goldShowLabel }, translate("search.goldshow")),
        showType === "specialShow" && React.createElement("div", { className: classes.specialShowLabel }, translate("search.specialshow"))));
};
exports.PerformerItemLabels = PerformerItemLabels;
//# sourceMappingURL=PerformerItemLabels.js.map